<template>
    <section v-if="json" class="filter-set">
        <div class="capper">
            <div class="capper-padded">
                <div class="top">
                    <div class="selected-filters">
                        <div class="selected-filters2">
                            <!-- Loop through selectedFilters to show the selected filters -->
                            <div
                                v-for="(filter, index) in selectedFilters"
                                :key="index"
                                class="selected-filter Zlink-underline-leftright-gray"
                                @click="clickFilter(filter)"
                            >
                                <span class="mini-x"></span> {{ filter.title }}
                            </div>
                            <div
                                v-if="selectedFilters.length > 1"
                                class="selected-filter Zlink-underline-leftright-gray"
                                @click="clickFilter('all')"
                            >
                                <span class="mini-x"></span>Clear
                            </div>
                            <div class="final">
                                <div class="dot"></div>
                                <div @click="toggleFilters" class="txt filterbar-toggle-hook">FILTER</div>
                            </div>
                        </div>
                    </div>

                    <div class="filters">
                        <div class="filters2">
                            <template v-for="(item, index) in projectCategories" :key="index">
                                <div
                                    :class="['filter', 'Zlink-underline-leftright-gray', { 'active': selectedFilters.some(filter => filter.slug === item.slug) }]"
                                    :data-slug="item.slug"
                                    @click="clickFilter(item)"
                                >
                                    {{ item.title }}
                                </div>
                                <!-- Add a dot after each filter except the last one -->
                                <div v-if="index !== projectCategories.length - 1" class="dot"></div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "FilterSet",
    data() {
        return {
            window: window,
            json: null,
            isFilterOpen: false,
        };
    },
    computed: {
        ...mapState({
            selectedFilters: (state) => state.selectedFilters,
            deepFilterLink: (state) => state.deepFilterLink,
        }),
        projectCategories() {
            return this.json.config.projectCategories;
        },
    },
    watch: {
        selectedFilters: {
            handler(newFilters) {
                // Generate the `filter` parameter
                const slugs = newFilters.map((filter) => filter.slug).join(",");

                // Get existing query parameters
                const urlParams = new URLSearchParams(window.location.search);

                if (slugs) {
                    // Update the `filter` parameter
                    urlParams.set("filter", slugs);
                } else {
                    // Remove the `filter` parameter if no filters are selected
                    urlParams.delete("filter");
                }

                // Update the browser's URL without reloading the page
                const queryString = urlParams.toString();
                const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
                window.history.pushState({}, "", newUrl);
            },
            deep: true,
        },
        deepFilterLink: {
            handler() {
                setTimeout(this.doDeepFilterLinkCheck,750)
            },
            deep: true,
        }
    },
    mounted() {
        this.isFilterOpen = false;
        this.json = this.window.config.json.global;

        // Reset filters
        this.$store.commit("filterClick", "all");

        // Detect filters from URL on page load
        const urlParams = new URLSearchParams(window.location.search);
        const filtersFromUrl = urlParams.get("filter");

        if (filtersFromUrl) {
            const slugs = filtersFromUrl.split(",");
            slugs.forEach((slug) => {
                const filter = this.projectCategories.find((item) => item.slug === slug);
                if (filter) {
                    this.$store.commit("filterClick", filter);
                }
            });
        }
        this.doDeepFilterLinkCheck()
    },
    beforeUnmount() {
        // Reset filters
        this.$store.commit("filterClick", "all");
    },
    methods: {
        doDeepFilterLinkCheck() {
            if (this.deepFilterLink) {
                this.deepFilterLink.forEach((filter) => {
                    this.$store.commit("filterClick", filter);
                });

                this.$store.commit("setDeepFilterLink", null);

                this.$nextTick(() => {
                    // Wait for Vue to render first
                    requestAnimationFrame(() => {
                        this.openFilters();
                    });
                });
            }
        },

        clickFilter(item) {
            this.$store.commit("filterClick", item);
        },
        toggleFilters() {
            if (this.isFilterOpen) {
                setTimeout(this.closeFilters,10)
            } else {
                setTimeout(this.openFilters,10)
            }
        },
        openFilters() {
            this.isFilterOpen = true
            const filtersElement = this.$el.querySelector(".filters");
            const inner = filtersElement?.querySelector(".filters2");

            let h = inner?.getBoundingClientRect().height || 46;
            filtersElement.style.height = `${h}px`;
        },
        closeFilters() {
            this.isFilterOpen = false
            const filtersElement = this.$el.querySelector(".filters");
            filtersElement.style.height = "0"; // Collapse

        },
    },
};
</script>
